// City → [lat, lng] lookup used to geocode venue records for the map.
// The LYVE directory venue records carry city + country but no coordinates,
// so venues are placed at their city centre.

export const CITY_COORDS = {
  Amsterdam: [52.3676, 4.9041],
  'Ann Arbor': [42.2808, -83.743],
  Antwerp: [51.2194, 4.4025],
  'Assago (Milan)': [45.403, 9.124],
  Athens: [37.9838, 23.7275],
  Atlanta: [33.749, -84.388],
  Austin: [30.2672, -97.7431],
  Bærum: [59.92, 10.53],
  Barcelona: [41.3851, 2.1734],
  Berlin: [52.52, 13.405],
  Birmingham: [52.4862, -1.8904],
  Boston: [42.3601, -71.0589],
  Brooklyn: [40.6782, -73.9442],
  Brussels: [50.8503, 4.3517],
  Budapest: [47.4979, 19.0402],
  Cardiff: [51.4816, -3.1791],
  Chicago: [41.8781, -87.6298],
  Cologne: [50.9375, 6.9603],
  'Columbia, MD': [39.2037, -76.861],
  Copenhagen: [55.6761, 12.5683],
  Dublin: [53.3498, -6.2603],
  'East Kilbride': [55.7644, -4.177],
  'East Rutherford, NJ': [40.8333, -74.0833],
  Edinburgh: [55.9533, -3.1883],
  'Elmont, NY': [40.7, -73.7128],
  Frankfurt: [50.1109, 8.6821],
  Glasgow: [55.8642, -4.2518],
  Hamburg: [53.5511, 9.9937],
  'Indio, CA': [33.7206, -116.2156],
  Inglewood: [33.9617, -118.3531],
  Kraków: [50.0647, 19.945],
  'Las Vegas': [36.1699, -115.1398],
  Leeds: [53.8008, -1.5491],
  Lisbon: [38.7223, -9.1393],
  Liverpool: [53.4084, -2.9916],
  London: [51.5074, -0.1278],
  'Los Angeles': [34.0522, -118.2437],
  Lyon: [45.764, 4.8357],
  Madrid: [40.4168, -3.7038],
  Manchester: [53.4808, -2.2426],
  Miami: [25.7617, -80.1918],
  'Miami Beach': [25.7907, -80.13],
  'Miami Gardens': [25.942, -80.2456],
  Milan: [45.4642, 9.19],
  'Morrison, CO': [39.6536, -105.1911],
  Munich: [48.1351, 11.582],
  Nanterre: [48.8924, 2.207],
  Nashville: [36.1627, -86.7816],
  'New York': [40.7128, -74.006],
  Newcastle: [54.9783, -1.6178],
  Oeiras: [38.6917, -9.3111],
  Oslo: [59.9139, 10.7522],
  Paris: [48.8566, 2.3522],
  Porto: [41.1579, -8.6291],
  Prague: [50.0755, 14.4378],
  Queens: [40.7282, -73.7949],
  Rome: [41.9028, 12.4964],
  Rotterdam: [51.9244, 4.4777],
  'Saint-Denis': [48.9362, 2.3574],
  'San Francisco': [37.7749, -122.4194],
  Sheffield: [53.3811, -1.4701],
  Solna: [59.36, 18.0],
  Stockholm: [59.3293, 18.0686],
  Tampere: [61.4978, 23.761],
  Valencia: [39.4699, -0.3763],
  Vienna: [48.2082, 16.3738],
  'Washington DC': [38.9072, -77.0369],
  'West Hollywood': [34.09, -118.3617],
  Zurich: [47.3769, 8.5417],
};

export function cityCoords(city) {
  if (!city) return null;
  return CITY_COORDS[city] || null;
}

export default CITY_COORDS;
